module.exports = __webpack_public_path__ + "img/4_145.5b36e556.png";